import { apiFetch } from './http';

/**
 * Scheduler API (cutover §3 — backend routes registered over the
 * scheduler_jobs collection, migration 1789900013). The list feeds
 * SchedulerPage fetch-first; both mutations roll back optimistic UI on
 * failure — see features/scheduler/SchedulerPage.jsx.
 */

/** The session tenant's schedule rows, newest-edited first server-side
 * (memoryPb/PB: title order). Empty array is a valid live state. */
export function listSchedulerJobs() {
  return apiFetch('/api/scheduler/jobs');
}

export function rescheduleJob(jobId, startHour) {
  return apiFetch(`/api/scheduler/jobs/${jobId}`, {
    method: 'PATCH',
    body: JSON.stringify({ startHour })
  });
}

export function updateJobCron(jobId, cron) {
  return apiFetch(`/api/scheduler/jobs/${jobId}`, {
    method: 'PATCH',
    body: JSON.stringify({ cron })
  });
}
